/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TemplateAttributeForm } from './';
import {
    TemplateAttributeFormFromJSON,
    TemplateAttributeFormFromJSONTyped,
    TemplateAttributeFormToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalNoticesForm
 */
export interface LegalNoticesForm {
    /**
     * 
     * @type {string}
     * @memberof LegalNoticesForm
     */
    template: string;
    /**
     * 
     * @type {Array<TemplateAttributeForm>}
     * @memberof LegalNoticesForm
     */
    attributes: Array<TemplateAttributeForm>;
}

/**
 * Check if a given object implements the LegalNoticesForm interface.
 */
export function instanceOfLegalNoticesForm(value: object): value is LegalNoticesForm {
    if (!('template' in value) || value['template'] === undefined) return false;
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    return true;
}

export function LegalNoticesFormFromJSON(json: any): LegalNoticesForm {
    return LegalNoticesFormFromJSONTyped(json, false);
}

export function LegalNoticesFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalNoticesForm {
    if (json == null) {
        return json;
    }
    return {
        
        'template': json['template'],
        'attributes': ((json['attributes'] as Array<any>).map(TemplateAttributeFormFromJSON)),
    };
}

export function LegalNoticesFormToJSON(value?: LegalNoticesForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'template': value['template'],
        'attributes': ((value['attributes'] as Array<any>).map((v) => TemplateAttributeFormToJSON(v))),
    };
}

